'use client'

import Image from 'next/image'
import type { ProductMessage } from '../../../../types/messageTypes'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { DEFAULT_LOOK_ID } from 'product/constants/constants'
import { useProductInfo } from 'product/services/productInfo/client'
import { cx } from 'utils/cx'
import styles from './ProductImage.module.scss'

const FULL_SIZE_IMAGE_WIDTH = '174px'
const MID_SIZE_IMAGE_WIDTH = '87px'

export function ProductImage({
	product,
	hasFullSizeImage,
	className,
}: Readonly<{
	product: ProductMessage
	hasFullSizeImage: boolean
	className: string
}>) {
	const {
		country: { countryISO, languageISO },
	} = useMasterData()

	const { data } = useProductInfo({
		productId: product.id,
		country: countryISO,
		language: languageISO,
	})

	const colorInfo = data?.colors.find((color) => color.id === product.color)
	const defaultLook = colorInfo?.looks[DEFAULT_LOOK_ID]

	const image = defaultLook?.images.B?.img

	return image ? (
		<div className={cx(styles.imageContainer, className)}>
			<Image
				src={image}
				alt={product.id}
				priority
				fill
				className={styles.image}
				sizes={hasFullSizeImage ? FULL_SIZE_IMAGE_WIDTH : MID_SIZE_IMAGE_WIDTH}
			/>
		</div>
	) : null
}
